import { useFormSchema } from "src/api/hooks/useFormSchema";

export const RadioWidget = (props: any) => {
  const { value, onChange, label, required, options, id, uiSchema } = props;
  const enumOptions = options?.enumOptions || [];
  const { data: schema } = useFormSchema();

  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`radio-container container`}>
      <div className="flex flex-col gap-2">
        {enumOptions.map((option: any, index: number) => (
          <label key={index} className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              className={`input-radio`}
              radioGroup={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              required={required}
            />
            <span className="text-sm">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
